/* istanbul ignore file */
import React from 'react';
import {
  Root,
  Routes,
  useSiteData,
} from 'react-static';
import { Router } from '@reach/router';
import styled, { ThemeProvider } from 'styled-components';
// template components
import GlobalStyles from '@nmx/template/dist/cjs/componentLibrary/foundations/GlobalStyles';
import Loading from '@nmx/template/dist/cjs/componentLibrary/components/Loading';
import Theme from '@nmx/template/dist/cjs/componentLibrary/Theme';
// global components
import ScrollToJumpLinksUtility from './pages/components/scrollToJumpLinksUtility';

export const LoadingStyled = styled(Loading)`
  margin-top: 25%;
`;

function App() {
  // Signal to Playwright visual-regression tests that JS breakpoints have
  // finished initialising. React's useMediaQuery hooks fire setState during
  // hydration; those updates are flushed as microtasks. setTimeout(0) is a
  // macrotask, so it runs *after* all pending React batched updates — meaning
  // the desktop repaint has already occurred before Playwright reads the flag.
  React.useEffect(() => {
    const id = setTimeout(() => {
      // "data-breakpoints-ready" is the attribute name used by Playwright tests to determine when breakpoints are ready.
      document.body.dataset.breakpointsReady = 'true';
    }, 0);
    return () => clearTimeout(id);
  }, []);

  const getConfig = () => {
    try {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      const { config } = useSiteData(); // NOSONAR
      return config;
    // eslint-disable-next-line no-unused-vars
    } catch (err) {
      // local hotloader won't work with useSiteData so we mock it for local dev.
      return {
        nmxTemplateVersion: '3.18.2',
        basePath: 'https://qa.new.northwesternmutual.com',
      };
    }
  };
  return (
    <Root>
      <ThemeProvider theme={Theme.render(typeof window !== 'undefined' ? window.innerWidth : 480, typeof window !== 'undefined' ? window.innerHeight : 900)}>
        <React.Suspense
          fallback={
            <LoadingStyled>Loading content</LoadingStyled>
          }>
          <GlobalStyles config={getConfig()} />
          {/* handles smooth scrolling to jump links for the entire site */}
          <ScrollToJumpLinksUtility />
          <Router>
            <Routes default />
          </Router>
        </React.Suspense>
      </ThemeProvider>
    </Root>
  );
}

export default App;
